<template>
    <div class="flex flex-col gap-2">
        <component
            :is="child.component"
            v-for="(child, index) in children"
            :key="`${child.slug}-${index}`"
            class="dashboard-widget"
            :slug="child.slug"
            :settings="child.settings ?? {}"
            :data="child.data"
        ></component>

        <div v-if="children.length === 0" class="p-3 text-xs text-center opacity-60">
            {{ lang('admin.dashboard.widgets.column.empty') }}
        </div>
    </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { lang } from '@/lang/composable';

interface ColumnChild {
    slug: string;
    component: string;
    settings?: Record<string, unknown>;
    data: Record<string, unknown>;
}

const props = defineProps<{
    slug?: string;
    settings?: Record<string, unknown>;
    data?: { children?: ColumnChild[] };
}>();

const children = computed<ColumnChild[]>(() => props.data?.children ?? []);
</script>
